import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet'
import { helmetJsonLdProp } from 'react-schemaorg'
import { getSrc } from 'gatsby-plugin-image'
import useSiteMetadata from '@helpers-blog/useSiteMetadata'
import getImageVariant from '@components/utils/getImageVariant'

const Seo = ({
  title,
  description,
  excerpt,
  meta,
  keywords,
  author,
  category,
  date,
  timeToRead,
  children,
  thumbnail,
  siteUrl,
  locale
}) => {
  const site = useSiteMetadata()

  // State for redtrack script
  const [redScriptInjected, setRedScriptInjected] = useState(false);

  useEffect(() => {
    // Function to check if the script should be injected
    const shouldInjectRedScript = () => {
      const targetPaths = [
        '/quiz',
        '/stay-cool-and-beat-the-heat-must-have-gadgets-for-a-refreshing-summer',
        '/ready-for-the-next-pandemic-essential-gadgets-and-survival-tips-to-prepare-for-the-unknown',
        '/i-recently-discovered-how-to-refrigerate-any-room-in-my-house-in-under-5-minutes-without-using-my-homes-costly-ac',
        '/ready-for-the-next-pandemic-neither-was-this-bug-guy-who-is-the-creator-of-a-revolutionary-new-virus-killing-bug-trap-that-could-save-millions-of-lives'
      ];
      const currentUrl = window.location.href;
    
      return targetPaths.some(targetPath => currentUrl.includes(targetPath));
    };

    // Inject the script if the condition is met and it hasn't been injected before
    if (shouldInjectRedScript() && !redScriptInjected) {
      const scriptElement = document.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.src = '//xr3432zl.rdtk.io/track.js';
      document.head.appendChild(scriptElement);

      // Update the state to mark the script as injected
      setRedScriptInjected(true);
    }
  }, [redScriptInjected]);


  const social = (author && author.social) || site.social || []
  const twitter =
    social.find(s => s.name && s.name.toLowerCase() === 'twitter') || {}

  description = excerpt || description || site.description

  const imageSrc = getSrc(getImageVariant(thumbnail, 'hero'))
  const imageUrl =
    imageSrc &&
    (imageSrc.startsWith('//') ? imageSrc : siteUrl && `${siteUrl}${imageSrc}`)

  // Function to get query parameters
  const getQueryStringValue = (key) => {
    if (typeof window === 'undefined') {
      return null;
    }
    return new URLSearchParams(window.location.search).get(key);
  };

  // Function to delete a cookie
  const deleteCookie = (name) => {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  const googleTranslateElementInit = () => {
    const language = getQueryStringValue('lang') || 'es'; // Get language from query string or default to 'es'

    new google.translate.TranslateElement({
      pageLanguage: 'en',
      includedLanguages: language,
      autoDisplay: false
    }, 'google_translate_element');

    let a = document.querySelector("#google_translate_element select");
    a.selectedIndex = 1;
    a.dispatchEvent(new Event('change'));
  };

  useEffect(() => {
    if (site.name && site.name === "moneymissle") {
      // Check if the meta tag already exists
      const existingMetaTag = document.querySelector('meta[name="impact-site-verification"]');
      if (!existingMetaTag) {
        const metaTag = document.createElement('meta');
        metaTag.name = 'impact-site-verification';
        metaTag.content = 'dc1a3a2c-dca7-48d9-946d-9be2086000c6';
        document.head.appendChild(metaTag);
      }
    } 
   
    
    if ((site.name && site.name === "BestLife") || getQueryStringValue('site_referer') === "BestLife") {
      let language = getQueryStringValue('lang') || 'es'; // Get language from query string or default to 'es'
      let expires = "";
      let date = new Date();
      date.setTime(date.getTime() + (30*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();

      // Delete the old cookie
      deleteCookie("googtrans");

      // Set a new cookie for the desired language
      document.cookie = "googtrans=/en/" + language + expires + "; path=/";

      let addScript = document.createElement('script');
      addScript.setAttribute('src', 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
      document.body.appendChild(addScript);

      if (window) {
        window.googleTranslateElementInit = googleTranslateElementInit;
      }
    }
  }, [])


  /*const googleTranslateElementInit = () => {

      new google.translate.TranslateElement({
        pageLanguage: 'en',
        includedLanguages: 'es',
        autoDisplay: false
      }, 'google_translate_element');
      var a = document.querySelector("#google_translate_element select");
      a.selectedIndex = 1;
      a.dispatchEvent(new Event('change'));

    //new window.google.translate.TranslateElement({ pageLanguage: 'en',  }, 'google_translate_element')

  }

  const getQueryStringValue = (key) => {
    if (typeof window === 'undefined') {
      return null;
    }
    return new URLSearchParams(window.location.search).get(key);
  };

  useEffect(() => {

    if ((site.name && site.name === "BestLife") ||  getQueryStringValue('site_referer') === "BestLife") {
      let expires = "";
      let date = new Date();
      date.setTime(date.getTime() + (30*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();

      document.cookie = "googtrans=/en/es"  + expires + "; path=/";

      let addScript = document.createElement('script');
      addScript.setAttribute('src', 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
      document.body.appendChild(addScript);

      if (window) {
        window.googleTranslateElementInit = googleTranslateElementInit;
      }

    }

  }, [])*/

  /**
   * Meta Tags
   */

  const metaTags = [
    { itemprop: 'name', content: title || site.title },
    { itemprop: 'description', content: description },
    { name: 'description', content: description },

    { property: 'og:title', content: title || site.title },
    { property: 'og:description', content: description },
    { property: 'og:type', content: date ? 'article' : 'website' },
    { property: 'og:site_name', content: site.name },
    { property: 'og:image', content: imageUrl },

    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:site', content: site.name },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:creator', content: twitter.url }
  ]

  if (keywords && keywords.length > 0) {
    metaTags.push({ name: 'keywords', content: keywords.join(', ') })
  }

  if (date) {
    metaTags.push({ name: 'article:published_time', content: date })
  }

  if (timeToRead) {
    metaTags.push({ name: 'twitter:label1', value: 'Reading time' })
    metaTags.push({
      name: 'twitter:data1',
      value: `${timeToRead} min read`
    })
  }

  if (meta) {
    metaTags.push(meta)
  }

  /**
   * Structured Data (JSON-LD)
   */

  const scripts = []

  // Article
  if (title && author) {
    const articleJsonLd = helmetJsonLdProp({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: title,
      image: imageUrl,
      datePublished: date,
      author: {
        '@type': 'Person',
        name: author.name,
        url: author.slug
      }
    })
    scripts.push(articleJsonLd)
  }

  // Breadcrumb
  if (title && category) {
    const breadcrumbJsonLd = helmetJsonLdProp({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: site.name,
          item: siteUrl
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: category.name,
          item: `${siteUrl}${category.slug}`
        }
      ]
    })
    scripts.push(breadcrumbJsonLd)
  }

  return (
    <Helmet
      htmlAttributes={{
        lang: locale || 'en'
      }}
      title={title}
      titleTemplate={`%s | ${site.title}`}
      meta={metaTags}
      script={scripts}
    >
    <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5555030135342556" crossOrigin="anonymous"></script>

    <script type="text/javascript" src="https://assets.revcontent.com/master/delivery.js" defer="defer"></script>

      {
          site.name && (
              site.name === "VisionQuesters" ? (
                  <link rel="shortcut icon" type="image/png" href="/vq-favicon.png"/>
              ) : site.name === "BestLife" ? (
                  <link rel="shortcut icon" type="image/png" href="/bl-favicon.png"/>
              ) : site.name === "ElonMuskHub" ? (
                  <link rel="shortcut icon" type="image/png" href="/elon-favicon.png"/>
              ) : site.name === "RedRightReport" ? (
                  <link rel="shortcut icon" type="image/png" href="/rrr-favicon.png"/>
              ) : site.name === "LocalRadarWeather" ? (
                  <link rel="shortcut icon" type="image/png" href="/weather-favicon.png"/>
              ) : (
                  <link rel="shortcut icon" type="image/png" href="/favicon.png"/>
              )
          )
      }
      {children}
    </Helmet>
  )
}


export default Seo
